document.addEventListener('DOMContentLoaded', () => {

  // ═══════════════════════════════════════════
  // MONEY FORMATTER
  // ═══════════════════════════════════════════

  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  // ═══════════════════════════════════════════
  // STATE
  // ═══════════════════════════════════════════

  let selectedDiamondVariant = window.builderData?.diamondVariant || null;
  let ringVariant            = null;
  let diamondPrice           = window.builderData?.diamondPrice   || 0;
  let selectedRingProduct    = null;
  let selectedOptions        = {};

  // ═══════════════════════════════════════════
  // STEP NAVIGATION
  // ═══════════════════════════════════════════

  const steps    = document.querySelectorAll('.step');
  const contents = document.querySelectorAll('.builder-step-content');

  function goToStep(stepNum) {
    contents.forEach(c => c.classList.remove('active'));
    steps.forEach(s => s.classList.remove('active'));
    document.getElementById(`step-${stepNum}`).classList.add('active');
    document.querySelector(`.step[data-step="${stepNum}"]`).classList.add('active');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  document.querySelectorAll('.next-step').forEach(btn => {
    btn.addEventListener('click', () => goToStep(btn.dataset.next));
  });

  steps.forEach(step => {
    if (!step.dataset.step) return;
    step.addEventListener('click', () => goToStep(step.dataset.step));
  });

  // Open builder directly on Step 2
  goToStep(2);

  // ═══════════════════════════════════════════
  // SELECTED GEMSTONE SUMMARY
  // ═══════════════════════════════════════════

  const gemHandle = localStorage.getItem('selectedGemstoneHandle');

  if (gemHandle) {
    fetch(`/products/${gemHandle}.js`)
      .then(r => r.json())
      .then(gemstone => {
        const summary = document.getElementById('selected-gemstone-summary');
        if (!summary) return;
        summary.innerHTML = `
          <div class="selected-gemstone-card">
            <div class="selected-gemstone-image">
              <img src="${gemstone.featured_image}" alt="${gemstone.title}">
            </div>
            <div class="selected-gemstone-content">
              <div class="selected-label">Selected Gemstone</div>
              <h3>${gemstone.title}</h3>
              <div class="selected-price">${formatMoney(gemstone.price)}</div>
            </div>
          </div>
        `;
      })
      .catch(err => console.error('Gemstone fetch error:', err));
  }

  // ═══════════════════════════════════════════
  // GEMSTONE TYPE DETECTION
  // ═══════════════════════════════════════════

  function getGemstoneType() {
    const handle = (localStorage.getItem('selectedGemstoneHandle') || '').toLowerCase();

    let shape = '';
    let color = '';

    // Shape detection
    if      (handle.includes('round'))    shape = 'round';
    else if (handle.includes('oval'))     shape = 'oval';
    else if (handle.includes('pear'))     shape = 'pear';
    else if (handle.includes('marquise')) shape = 'marquise';
    else if (handle.includes('heart'))    shape = 'heart';
    else if (
      handle.includes('emerald-cut') ||
      handle.includes('square-emerald-cut') ||
      handle.includes('emerald')
    ) shape = 'emerald';
    else if (
      handle.includes('long-cushion') ||
      handle.includes('square-cushion') ||
      handle.includes('cushion')
    ) shape = 'cushion';

    // Color detection
    if      (handle.includes('colombian-emerald'))                      color = 'colombianEmerald';
    else if (handle.includes('paraiba'))                                color = 'paraiba';
    else if (handle.includes('pink') && handle.includes('sapphire'))    color = 'pinkSapphire';
    else if (handle.includes('sapphire'))                               color = 'sapphire';
    else if (handle.includes('ruby'))                                   color = 'ruby';
    else if (handle.includes('emerald'))                                color = 'emerald';

    return { shape, color };
  }

  const COLOR_NAME_MAP = {
    sapphire        : 'Sapphire',
    pinkSapphire    : 'PinkSapphire',
    ruby            : 'Ruby',
    emerald         : 'Emerald',
    colombianEmerald: 'ColombianEmerald',
    paraiba         : 'Paraiba',
  };

  // ═══════════════════════════════════════════
  // CARD FILTERING
  // ═══════════════════════════════════════════

  function filterRingCards() {
    const gem = getGemstoneType();
    if (!gem.shape || !gem.color) return;

    const colorName = COLOR_NAME_MAP[gem.color];
    const keys = [
      `${gem.shape}${colorName}Yellow`,
      `${gem.shape}${colorName}White`,
    ];

    document.querySelectorAll('.ring-card').forEach(card => {
      const button = card.querySelector('.select-diamond');
      if (!button) return;

      const hasImage = keys.some(key => {
        const val = button.dataset[key];
        return val && val.trim() !== '';
      });

      card.style.display = hasImage ? '' : 'none';
    });

    updateGridVisibility();
  }

  function updateGridVisibility() {
    const grid    = document.querySelector('.diamond-grid');
    const message = document.getElementById('no-settings-message');
    if (!grid || !message) return;

    const visibleCards = document.querySelectorAll(
      '.ring-card:not([style*="display: none"])'
    );

    if (visibleCards.length === 0) {
      grid.style.display    = 'none';
      message.style.display = 'block';
    } else {
      grid.style.display    = '';
      message.style.display = 'none';
    }
  }

  // ═══════════════════════════════════════════
  // SETTING CARD IMAGES
  // ═══════════════════════════════════════════

  function initCardImage(button) {
    const card  = button.closest('.diamond-card');
    const image = card?.querySelector('.setting-card-image');
    if (!image) return;

    const gem       = getGemstoneType();
    const colorName = COLOR_NAME_MAP[gem.color];
    const yellowKey = `${gem.shape}${colorName}Yellow`;
    const imageUrl  = button.dataset[yellowKey];

    if (imageUrl) image.src = 'https:' + imageUrl;
  }

  // ── Bind "Add To Settings" click on a single button ──
  function initSelectButton(button) {
    button.addEventListener('click', () => {

      selectedRingProduct = JSON.parse(button.dataset.product);
      selectedOptions     = {};

      const gem       = getGemstoneType();
      const colorName = COLOR_NAME_MAP[gem.color];
      const yellowKey = `${gem.shape}${colorName}Yellow`;
      const whiteKey  = `${gem.shape}${colorName}White`;
      const yellowImg = button.dataset[yellowKey];
      const whiteImg  = button.dataset[whiteKey];

      const galleryImages = [yellowImg, whiteImg].filter(Boolean);

      if (galleryImages.length) {
        window.currentGemstoneImages = galleryImages;
        setMainImage('https:' + galleryImages[0]);
        renderGallery(galleryImages.map(url => ({ src: url })));
      }

      document.getElementById('ring-configurator').style.display = 'block';
      document.getElementById('config-title').innerHTML  = selectedRingProduct.title;
      document.getElementById('config-price').innerHTML  = formatMoney(selectedRingProduct.price);

      // Render all variant options dynamically
      const optionsContainer = document.getElementById('dynamic-options');
      optionsContainer.innerHTML = '';

      selectedRingProduct.options.forEach((optionName, index) => {
        const optionKey = 'option' + (index + 1);
        const values    = [...new Set(
          selectedRingProduct.variants.map(v => v[optionKey])
        )].filter(Boolean);

        const group = document.createElement('div');
        group.className   = 'config-group';
        group.innerHTML   = `
          <h4>${optionName}</h4>
          <div class="option-buttons" id="option-${index}"></div>
        `;
        optionsContainer.appendChild(group);

        const btnWrap = group.querySelector('.option-buttons');

        values.forEach(value => {
          const btn       = document.createElement('button');
          btn.className   = 'variant-btn';
          btn.dataset.value  = value;
          btn.dataset.option = optionKey;
          btn.textContent    = value;

          btn.addEventListener('click', () => {
            btnWrap.querySelectorAll('.variant-btn')
              .forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            selectedOptions[optionKey] = value;
            updateVariantImage();
          });

          btnWrap.appendChild(btn);
        });
      });

      document.getElementById('ring-configurator')
        .scrollIntoView({ behavior: 'smooth' });
    });
  }

  // ── Initialize all existing cards ──
  function initAllCards() {
    document.querySelectorAll('.select-diamond').forEach(button => {
      initCardImage(button);
      initSelectButton(button);
    });
  }

  initAllCards();
  filterRingCards();

  // ═══════════════════════════════════════════
  // IMAGE HELPERS
  // ═══════════════════════════════════════════

  function setMainImage(src) {
    const img = document.getElementById('config-image');
    if (!img) return;
    img.classList.add('loading');
    img.src    = src;
    img.onload = () => img.classList.remove('loading');
  }

  function renderGallery(images) {
    const gallery = document.getElementById('config-gallery');
    if (!gallery) return;
    gallery.innerHTML = '';
    if (!images || images.length <= 1) return;

    images.slice(0, 8).forEach((image, i) => {
      const src = typeof image === 'string'
        ? 'https:' + image.split('?')[0]
        : 'https:' + image.src.split('?')[0];

      const thumb     = document.createElement('img');
      thumb.className = 'config-gallery-thumb' + (i === 0 ? ' active' : '');
      thumb.src       = src;
      thumb.alt       = image.alt || '';

      thumb.addEventListener('click', () => {
        document.querySelectorAll('.config-gallery-thumb')
          .forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        setMainImage(src);
      });

      gallery.appendChild(thumb);
    });
  }

  function getVariantImages(variant) {
    if (!selectedRingProduct) return [];
    if (variant?.featured_media) {
      const variantImages = selectedRingProduct.images.filter(img =>
        img.variant_ids?.includes(variant.id)
      );
      return variantImages.length > 0 ? variantImages : selectedRingProduct.images;
    }
    return selectedRingProduct.images || [];
  }

  function findMatchedVariant() {
    if (!selectedRingProduct) return null;
    return selectedRingProduct.variants.find(v =>
      Object.entries(selectedOptions).every(([key, val]) => v[key] === val)
    );
  }

  function updateVariantImage() {
    const matched = findMatchedVariant();
    if (!matched) return;

    if (window.currentGemstoneImages?.length) {
      const metal = selectedOptions.option1;
      setMainImage(
        metal === 'White Gold'
          ? 'https:' + window.currentGemstoneImages[1]
          : 'https:' + window.currentGemstoneImages[0]
      );
    }

    document.getElementById('config-price').innerHTML = formatMoney(matched.price);
  }

  // ═══════════════════════════════════════════
  // CONFIRM SETTING
  // ═══════════════════════════════════════════

  document.getElementById('confirm-ring').addEventListener('click', () => {

    if (!selectedRingProduct) {
      alert('Please select a setting first.'); return;
    }

    const optionNames = selectedRingProduct.options;
    const allSelected = optionNames.every((_, i) =>
      selectedOptions['option' + (i + 1)]
    );

    if (!allSelected) {
      alert('Please select all options: ' + optionNames.join(', ')); return;
    }

    const matchedVariant = findMatchedVariant();
    if (!matchedVariant) {
      alert('This combination is unavailable. Please try another.'); return;
    }

    ringVariant = matchedVariant.id;

    const optionSummary = optionNames
      .map((_, i) => selectedOptions['option' + (i + 1)])
      .join(' / ');

    let ringImgSrc = '';
    if (window.currentGemstoneImages?.length) {
      const metal = selectedOptions.option1;
      ringImgSrc  = metal === 'White Gold'
        ? 'https:' + window.currentGemstoneImages[1]
        : 'https:' + window.currentGemstoneImages[0];
    }

    document.getElementById('selected-diamond-content').innerHTML = `
      <img src="${ringImgSrc}"
        style="width:220px; margin-bottom:16px; display:block; background:#f0ebe3; padding:16px;">
      <h3 style="color:#fff; font-size:18px; margin-bottom:8px; font-weight:400;">
        ${selectedRingProduct.title}
      </h3>
      <div style="color:rgba(255,255,255,0.6); margin-bottom:8px; font-size:13px; letter-spacing:.5px;">
        ${optionSummary}
      </div>
      <div style="color:#fff; font-size:22px;">
        ${formatMoney(matchedVariant.price)}
      </div>
    `;

    document.getElementById('builder-total').innerHTML =
      formatMoney(matchedVariant.price + diamondPrice);

    goToStep(3);
  });

  // ═══════════════════════════════════════════
  // COMPLETE RING PURCHASE
  // ═══════════════════════════════════════════

  const completeButton = document.querySelector('.complete-ring-btn');

  completeButton.addEventListener('click', async () => {

    if (!selectedDiamondVariant) {
      alert('Diamond not found. Please go back and reselect.'); return;
    }
    if (!ringVariant) {
      alert('Please select and confirm a ring setting first.'); return;
    }

    completeButton.textContent = 'Adding to cart...';
    completeButton.disabled    = true;

    try {
      const response = await fetch('/cart/add.js', {
        method  : 'POST',
        headers : { 'Content-Type': 'application/json' },
        body    : JSON.stringify({
          items: [
            {
              id         : Number(ringVariant),
              quantity   : 1,
              properties : {
                '_paired_diamond': window.builderData?.diamondTitle || '',
                '_builder'       : 'ring-builder',
              },
            },
            {
              id         : Number(selectedDiamondVariant),
              quantity   : 1,
              properties : {
                '_paired_setting': selectedRingProduct?.title || '',
                '_builder'       : 'ring-builder',
              },
            },
          ],
        }),
      });

      if (response.ok) {
        window.location.href = '/cart';
      } else {
        const err = await response.json();
        alert('Error: ' + (err.description || 'Could not add to cart.'));
        completeButton.textContent = 'Complete Ring Purchase';
        completeButton.disabled    = false;
      }

    } catch (e) {
      alert('Something went wrong. Please try again.');
      completeButton.textContent = 'Complete Ring Purchase';
      completeButton.disabled    = false;
    }
  });

  // ═══════════════════════════════════════════
  // LOAD MORE BUTTON
  // ═══════════════════════════════════════════

  const grid        = document.getElementById('diamond-grid');
  const loadMoreBtn = document.getElementById('load-more-btn');

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', () => loadMoreCards(loadMoreBtn));
  }

  async function loadMoreCards(btn) {
    const nextUrl = btn.dataset.nextUrl;
    if (!nextUrl || !grid) return;

    const originalText = btn.textContent;
    btn.textContent    = 'Loading...';
    btn.disabled       = true;

    try {
      const res  = await fetch(nextUrl);
      const html = await res.text();

      const parser   = new DOMParser();
      const doc      = parser.parseFromString(html, 'text/html');
      const newCards = doc.querySelectorAll('.ring-card');

      // Append cards
      newCards.forEach(card => grid.appendChild(card));

      // Init new cards
      newCards.forEach(card => {
        const button = card.querySelector('.select-diamond');
        if (!button) return;
        initCardImage(button);
        initSelectButton(button);
      });

      // Rerun filter
      filterRingCards();

      // Check for next page button in fetched HTML
      const newLoadMore = doc.getElementById('load-more-btn');
      const nextPageUrl = newLoadMore?.dataset.nextUrl || null;

      if (nextPageUrl) {
        btn.dataset.nextUrl = nextPageUrl;
        btn.textContent     = originalText;
        btn.disabled        = false;
      } else {
        // No more pages
        btn.parentNode?.remove();
      }

    } catch (err) {
      console.error('Load more error:', err);
      btn.textContent = originalText;
      btn.disabled    = false;
    }
  }

});